import styles from './main.scss'
import React from 'react'
import { Link } from 'gatsby'

export const translations = {
  de: {
    cta: () => (
      <div className={styles.cta}>
        Bitte akzeptiere <Link to="/cookie-policy">Cookies</Link> für diesen Player
      </div>
    ),
    button: 'Anzeige erlauben',
  },
  en: {
    cta: () => (
      <div className={styles.cta}>
        Please accept <Link to="/cookie-policy">cookies</Link> for this player
      </div>
    ),
    button: 'Allow cookie',
  },
}
